const Paths = {
  // SITE_URL: "http://localhost:3000",
  SITE_URL: "https://smt-control-access.web.app/",
  // API_URL: "https://control-de-acceso-back-end-5o24w.ondigitalocean.app",
  API_URL: "https://control-de-acceso-back-end-2-5f5yo.ondigitalocean.app",
};

export default Paths;
